import { PrimitiveAtom, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Nullable } from '@/types/generic';

// generic hook that keeps param values in sync with their corresponding atoms
export const useSetIdAtom = (atom: PrimitiveAtom<Nullable<number>>, key: string) => {
  const params = useParams();
  const value = params[key];
  const setAtom = useSetAtom(atom);

  useEffect(() => {
    if (value) {
      setAtom(Number(value));
    } else {
      throw new Error(`Missing param in URL: ${key}`);
    }
  }, [value]);
};
